// packages/web/src/components/onboarding/invite-invalid.tsx
import { useTranslation } from "react-i18next";

export function InviteInvalid() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-md space-y-3 p-6">
      <h1 className="text-xl font-semibold text-ink-900">{t("onboarding.invite-invalid.title")}</h1>
      <p className="text-[13px] text-ink-700">{t("onboarding.invite-invalid.description")}</p>
    </div>
  );
}
